import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-paper text-ink" data-id="element-182" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-183" data-mp="3b1clhf1a98l9">
        <h2 id="testimonios" className="font-anton text-2xl uppercase leading-tight sm:text-3xl" data-id="element-184" data-mp="36yzgisud1epj">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-steel" data-id="element-185" data-mp="32290g5ik2j44">
          De no saber por dónde comenzar a comprender cómo se diseñan y
          fabrican muebles industriales.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-186" data-mp="2s430vuk81p2f">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border-2 border-ink/10 bg-white p-2.5 text-left" data-id="element-187" data-mp="v72hrm77d4la" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-188" data-mp="m5kkcjovulab">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={12} className="fill-gold text-gold" data-id="element-189" data-mp="79258ndnvh5x" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug text-ink/90 sm:text-sm" data-id="element-190" data-mp="c73pvcqqjoji">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-191" data-mp="14w296d6lgwqe">
                <p className="text-xs font-extrabold uppercase text-forge" data-id="element-192" data-mp="14ur4mb5brky8">
                  {t.author}
                </p>
                <p className="text-xs leading-snug text-steel" data-id="element-193" data-mp="v5ptay9q5rql">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.15} className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-gold bg-ink p-3" data-id="element-194" data-mp="1it7cw6iu5jih">
            <CtaButton href={OFFER_ANCHOR} data-id="element-195" data-mp="1xfwjesbi8wyd">🚀 Sí, quiero comenzar ahora</CtaButton>
            <p className="mt-2 text-xs font-semibold text-paper/80" data-id="element-196" data-mp="1sjpdgzj3zlgf">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}